export const formatPrice = (price) => {
  if (price) {
    const formattedPrice = `$${Number.parseFloat(price).toFixed(2)}`
    return formattedPrice.replace(/\.00$/, '')
  }
  return price
}

export const formatQuantity = number => `${number < 9 ? `0${number}` : number}`
